import React, { useEffect, useReducer, useRef  } from "react";
import { Heading } from './heading.module.js';
import CalculatePrice from '../../../shared/calculate-price.js'
import {InputRange} from './input.range.js';
import {InputNumber} from './input.number.js';
import {SellingModule} from './selling.module.js';
import {SellingValue} from './selling.value.js';
import  {SellingButton} from './selling-button.js';
import { ReportsCheckoutStripe, ReportsSearchEncode } from '../reports/reports.requests.js';
import { RangeComma } from '../reports/reports.body.js';
import {useAuth} from '../../legacy/helpers/authContext.js'
import {useLogin} from '../../legacy/helpers/loginContext.js'
import Login from '../../legacy/pages/Login/index.js'

import { useLocation, useSearchParams} from 'react-router-dom'

// Interface for loading state
interface LoadingState {
	paypal: boolean;
	stripe: boolean;
}

// Interface for error state
interface ErrorState {
	title: string;
	description: string;
	active: boolean;
}

// Interface for component state
interface SellingState {
	range: number;
	max: number;
	discovered: number;
	checked: boolean;
	loading: LoadingState;
	error: ErrorState;
}

// Interface for component props
interface SellingProps {
	max?: number;
	discovered?: number;
	completed?: boolean;
	tools?: boolean;
	allowPurchases?: boolean;
	list?: wts_ignore_any[];
} 

const CreateReturnURL = (): string => {
	const location = useLocation();
	const locationPath = location.pathname;
	let [searchParams, setSearchParams] = useSearchParams();
	const fullQueryString = searchParams.toString();

	if (fullQueryString.length == 0) return locationPath;

	return locationPath + '?' + fullQueryString;
}

const GenerateReportName = (): string => {

	// derive search parameters from URL parameters
	let [searchParams, setSearchParams] = useSearchParams();

	const technology = searchParams.get('technology');
	const version = searchParams.get('version');
	const header = searchParams.get('header');
	const category = searchParams.get('category');

	let orderDetails = '';

	if (undefined != technology) {
		if (undefined != version) {
			orderDetails = `Technology: ${technology}, version: ${version}`;
		}
		else {
			orderDetails = `Technology: ${technology}`;
		}
	}
	else if (undefined != header) {
		orderDetails = `HTTP Header: ${header}`;
	} else if (undefined != category) {
		orderDetails = `Category: ${category}`;
	}
	else {
		orderDetails = 'Generic Report';
		console.log(`[error]: unknown report type`)
	}

	return orderDetails;
}

const SellingReducer = function( state: SellingState, [ type, data ]: [string, wts_ignore_any] ): SellingState {

	if( type === "range" ){
		return {
			...state,
			range: data
		};
	}else if( type === "max" ){
		return {
			...state,
			max: data
		};
	}else if( type === "discovered" ){
		return {
			...state,
			discovered: data
		};
	}else if( type === "checked" ){
		return {
			...state,
			checked: data
		};
	}else if( type === "loading" ){
		return {
			...state,
			loading: {
				paypal: !!data.paypal,
				stripe: !!data.stripe
			}
		};
	}else if( type === "error" ){
		return {
			...state,
			error: {
				title: data.title || "",
				description: data.description || "",
				active: data.active === undefined ? true : data.active
			}
		};
	};

	return state;
};

export const Selling = ( props: SellingProps ) => {

	const [ state, dispatch ] = useReducer( SellingReducer, {
		range: 1000,
		max: props.max || 5000,
		discovered: props.discovered || 0,
		checked: false,
		loading: {
			paypal: false,
			stripe: false
		},
		error: { 
			title: '',
			description: "Terms and Conditions need to be checked", 
			active: false }
	});

    const {currentUser} = useAuth();
	const {setLoginType} = useLogin();
	const returnURL = CreateReturnURL();
	const reportName = GenerateReportName();

	useEffect(() => {
		dispatch([ "range", props.max ]);
		dispatch([ "max", props.max ]);
	}, [ props.max ]);
	useEffect(() => {
		dispatch([ "discovered", props.discovered ]);
	}, [ props.discovered ]);

	const min = state.discovered < 1000 ? state.discovered : 1000;
	const max = state.discovered < state.max  ? state.discovered : state.max;
	const range = state.range > max ? max : state.range;
	const rangeMinMax = range < min ? min : range;
	const completed = state.discovered > 0 && props.completed ? true : false;

	return(
		<div className={"selling-wrap"}>

			<div className={ "error" + (state.error.active ? " " : " hidden") }>
				<div className={ "error-close" } onClick={() => dispatch([ "error", { active: false } ]) }>X</div>
				<div className={ "error-title" }>{ state.error.title }</div>
				<div className={ "error-description" }>{ state.error.description }</div>
			</div>

			<SellingModule tools={ true }>
				<Heading heading={"Report Size"}/>
				<InputRange min={ min } max={ max } tools={ true } value={ range } dispatch={ dispatch }/>
{/*}				<InputNumber min={ min } max={ max } tools={ true } value={ range } dispatch={ dispatch }/>*/}
				<InputNumber min={ min } max={ max } value={ range } dispatch={ dispatch }/>
				<SellingValue text={"Include in report:"} value={ RangeComma( rangeMinMax ) } dispatch={ dispatch }/>
			</SellingModule>

			<Heading className={ "hidden" } heading={"Purchase Option"}/>
			<SellingModule tools={ true } hidden={ true }>
				<SellingValue text={"Available subscription reports:"} value={"1"}/>
				<SellingButton text={"Reedem Report"}/>
			</SellingModule>

			<SellingModule hidden={ true }>
				<SellingValue text={"Pay with credits (what are credits)"}/>
				<SellingValue text={"Credits available:"} value={"11, 145"}/>
				<SellingValue text={"Price:"} value={ "10 000 credits"}/>
				<SellingButton text={"Apply Credits"}/>
			</SellingModule>

			<div className={"selling-val"+ (props.tools ? " mb-sixteen" : "")}>
				<p className={"selling-val-text"+ (props.tools ? " fd-column" : "") }>
					<span className={"selling-val-text-item" + (props.tools ? " payment-string-text" : "")}></span>
					<span className={"selling-val-text-val"+ (props.tools ? " payment-string-val" : "")} >Price: ${CalculatePrice( rangeMinMax )}</span>
				</p>
				{
					currentUser ?
					<>
						{
							props.allowPurchases ? 
							<>
								<p className={
									"selling-btn"
									+ (state.loading.stripe ? " selling-btn-loading" : "")
									+ (!completed ? " selling-btn-inactive" : "")
								} onClick={() => {

								if( !completed )
									return;

								if( !state.checked ){
									dispatch([ "error", {
										title: "Error",
										description: "Terms and Conditions need to be checked"
									}]);
									return;
								};
								ReportsCheckoutStripe({
									count: range,
									checked: state.checked,
									details: ReportsSearchEncode({ list: props.list! }),
									reportName,
									returnURL
								}, dispatch );
								dispatch([ "loading", { stripe: true } ]);

							}}>Buy</p>
							<p className={"selling-checked"}>
								<svg className={ "selling-checked-checkbox" + (state.checked ? " selected-checkbox" : "") }
									viewBox="0 0 24 24"
									onClick={() => dispatch([ "checked", !state.checked ]) }
								>
									<path d="M6.445 12.668a.9.9 0 00-1.303
									1.242l3.573 3.745a.9.9 0 001.335-.036l8.591-10.037a.9.9
									0 00-1.367-1.17l-7.656 8.944a.4.4 0 01-.593.016l-2.58-2.704z"></path>
								</svg>

								<span className={"selling-checked-text"}>
									I agree with
									<a className={"selling-checked-href"} href={"/terms"} target={"_blank"}> Terms and Condition</a>
								</span>
							</p>
						</>:
						<>
							<br />
							<div className="alert alert-warning alert-dismissible fade show" role="alert">
								This account cannot be used for purchases. Please create an account with a real, non-disposable email or contact WebTechSurvey to enable your account for purchases
							</div>
						</>
						}
					</>:
					<>
						<br />
						<div className="alert alert-warning alert-dismissible fade show" role="alert">
							Please 
							<a 
								href='#' 
								className="alert-link"
								onClick={(e) => {
									e.preventDefault();
									setLoginType((<Login />))}}
							>
								{' '}log in {' '}
							</a> 
								to purchase the report
							<button type="button" className="close" data-dismiss="alert" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
					</>
				}
			</div>
		</div>


	)
};